/**
 * Environment store
 * Detects and stores information about the runtime environment
 */

import { writable, derived } from 'svelte/store';
import { detectEnvironment, loadTelegramSDK, type EnvironmentInfo } from '../lib/environment';

/**
 * Create environment store
 */
function createEnvironmentStore() {
  const { subscribe, set } = writable<EnvironmentInfo | null>(null);

  return {
    subscribe,

    /**
     * Initialize environment detection
     * Should be called on app mount
     * Loads Telegram SDK if needed before detection
     */
    initialize: async () => {
      // Try to load Telegram SDK if in Telegram environment
      await loadTelegramSDK();
      
      // Detect environment after SDK is loaded (or not)
      const info = detectEnvironment();
      set(info);
    },

    /**
     * Refresh environment info
     */
    refresh: () => {
      const info = detectEnvironment();
      set(info);
    },
  };
}

export const environment = createEnvironmentStore();

/**
 * Derived store for checking if mobile
 */
export const isMobile = derived(
  environment,
  ($env) => $env?.isMobile ?? false
);

/**
 * Derived store for checking if PWA
 */
export const isPWA = derived(
  environment,
  ($env) => $env?.isPWA ?? false
);

/**
 * Derived store for checking if Telegram
 */
export const isTelegram = derived(
  environment,
  ($env) => $env?.isTelegram ?? false
);

/**
 * Derived store for checking if Capacitor
 */
export const isCapacitor = derived(
  environment,
  ($env) => $env?.isCapacitor ?? false
);
